import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { rockIslandConfig } from "./data";

export default function RockIslandPage() {
  return <CityPageTemplate config={rockIslandConfig} />;
}